<div class="wa-messages-card">
  @if (showHeader) {
  <div class="wa-header">
    <h5>WhatsApp Messages</h5>
    @if (showViewDetail) {
    <button type="button" class="wa-view-detail" (click)="onViewDetail()" title="View in Detail">
      View in Detail
    </button>
    }
  </div>
  }

  @if (loading) {
  <div class="wa-loading-state">
    <div class="wa-loading-spinner"></div>
  </div>
  }

  @if (!loading && error) {
  <div class="wa-alert-error">{{ error }}</div>
  }

  @if (!loading && !error && messages.length > 0) {
  <div class="wa-messages-container">
    @for (msg of messages; track trackByMessageId($index, msg)) {
    <div class="wa-msg-row">
      @if (isMediaMessage(msg)) {
      <a [href]="msg.fileUrl || '#'" target="_blank" rel="noopener noreferrer" class="wa-msg-media-badge"
        [title]="msg.messageBody || 'Click to view media'">
        <span class="wa-media-icon-box" [class]="'media-type-' + (msg.messageType || 'file')">
          @if (msg.messageType === 'image') {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
          } @else if (msg.messageType === 'video') {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <polygon points="23 7 16 12 23 17 23 7"></polygon>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
          </svg>
          } @else if (msg.messageType === 'audio') {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
          </svg>
          } @else {
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
          }
        </span>
        <span class="wa-media-text">{{ msg.messageBody || getMediaFallbackLabel(msg.messageType) }}</span>
        <svg class="wa-media-ext-icon" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
          <polyline points="15 3 21 3 21 9"></polyline>
          <line x1="10" y1="14" x2="21" y2="3"></line>
        </svg>
      </a>
      } @else if (msg.messageBody) {
      <span class="wa-msg-text">{{ msg.messageBody }}</span>
      } @else {
      <span class="wa-msg-text wa-msg-text-unknown">{{ getMessageDisplayText(msg) }}</span>
      }
      <span class="wa-msg-time">{{ msg.createdAt | date:'MMM d, h:mm a' }}</span>
    </div>
    }
  </div>
  }

  @if (!loading && !error && messages.length === 0) {
  <div class="wa-empty-state">No WhatsApp messages found</div>
  }
</div>

@if (showModal) {
<div class="wa-modal-overlay" (click)="closeDetailModal()">
  <div class="wa-modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="wa-modal-header">
      <div class="wa-modal-header-info">
        <div class="wa-modal-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path
              d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">
            </path>
          </svg>
        </div>
        <div>
          <h5 class="wa-modal-title">WhatsApp Messages</h5>
          <span class="wa-modal-subtitle">Phone: {{ phoneNumber || 'N/A' }}</span>
          <span class="wa-modal-msg-count">{{ modalMessages.length }} message(s)</span>

        </div>
      </div>
      <button type="button" class="wa-modal-close-btn" (click)="closeDetailModal()" title="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="wa-modal-body">
      @if (modalLoading) {
      <div class="wa-loading-state p-4">
        <div class="wa-loading-spinner"></div>
        <span class="ml-2 text-muted" style="font-size: 0.88rem;">Loading messages...</span>
      </div>
      }

      @if (!modalLoading && modalError) {
      <div class="wa-alert-error m-3">{{ modalError }}</div>
      }

      @if (!modalLoading && !modalError && modalMessages.length > 0) {
      <div class="wa-chat-container">
        @for (msg of modalMessages; track trackByMessageId($index, msg)) {
        <div class="wa-chat-row" [class.wa-chat-incoming]="isIncoming(msg)" [class.wa-chat-outgoing]="!isIncoming(msg)">
          <div class="wa-chat-bubble" [class.bubble-incoming]="isIncoming(msg)"
            [class.bubble-outgoing]="!isIncoming(msg)">
            <div class="wa-chat-sender">
              {{ getSenderLabel(msg) }}
            </div>

            @if (msg.messageType === 'text' || !msg.messageType) {
            <div class="wa-chat-text">{{ msg.messageBody || msg.text || msg.message }}</div>
            } @else if (msg.messageType === 'image' && msg.fileUrl) {
            <div class="wa-chat-media">
              <img [src]="msg.fileUrl" alt="Image" class="wa-chat-img" />
              @if (msg.messageBody) { <div class="wa-chat-caption">{{ msg.messageBody }}</div> }
            </div>
            } @else if (msg.messageType === 'video' && msg.fileUrl) {
            <div class="wa-chat-media">
              <video [src]="msg.fileUrl" controls class="wa-chat-video"></video>
              @if (msg.messageBody) { <div class="wa-chat-caption">{{ msg.messageBody }}</div> }
            </div>
            } @else if (msg.messageType === 'document' && msg.fileUrl) {
            <div class="wa-chat-doc">
              <a [href]="msg.fileUrl" target="_blank" rel="noopener noreferrer">
                {{ msg.messageBody || 'View Document' }}
              </a>
            </div>
            } @else {
            <div class="wa-chat-text">{{ getMessageDisplayText(msg) }}</div>
            }

            <div class="wa-chat-time">{{ msg.createdAt | date:'dd MMM yyyy, hh:mm a' }}</div>
          </div>
        </div>
        }
      </div>
      }

      @if (!modalLoading && !modalError && modalMessages.length === 0) {
      <div class="wa-empty-state text-center p-4">No WhatsApp messages found</div>
      }
    </div>

    <!-- Footer -->
    <!-- <div class="wa-modal-footer">
      <span class="wa-modal-msg-count">{{ modalMessages.length }} message(s)</span>
      <button type="button" class="btn btn-secondary btn-sm" (click)="closeDetailModal()">Close</button>
    </div> -->
  </div>
</div>
}